package meineglasfaser.frontend.www.pages.portal.auth

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.role
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import io.ktor.client.plugins.ClientRequestException
import io.ktor.client.statement.bodyAsText
import meineglasfaser.api.routes.AuthRoutes.RealmCustomerPortal.ForgotStage2
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.ErrorCard
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.components.yaform.YaFormTextInput
import meineglasfaser.frontend.common.setJsonBody
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.CustomerState
import meineglasfaser.frontend.www.components.CustomerStateRedirectIfLoggedIn
import meineglasfaser.frontend.www.components.GlobalCustomerState
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*

private enum class Stage2State {
    NEW_PASSWORD,
    SUCCESS,
}

@Page("forgot/stage2")
@Layout(".components.layouts.ShopLayout")
@Composable
fun ForgotPage2(ctx: PageContext) {
    CustomerStateRedirectIfLoggedIn()
    val resetToken = ctx.route.queryParams["resetToken"]
    var state by remember { mutableStateOf(Stage2State.NEW_PASSWORD) }
    var errorText by remember { mutableStateOf<String?>(null) }

    Div(attrs = { classes("auth-form")}) {
        H1(attrs = { classes("text-center") }) {
            Text("Passwort zurücksetzen")
        }
        when (state) {
            Stage2State.NEW_PASSWORD if resetToken.isNullOrBlank() -> {
                P {
                    Text("Fehler: Reset-Link enthält kein Token.")
                }
            }
            Stage2State.NEW_PASSWORD -> {
                YaForm(
                    onSubmitScope = { data ->
                        val body = ForgotStage2.RequestBody(
                            resetToken = resetToken!!,
                            newPassword = data.string(ForgotStage2.RequestBody::newPassword),
                            newPasswordRepeat = data.string(ForgotStage2.RequestBody::newPasswordRepeat),
                        )
                        BackendApi.post(ForgotStage2()) {
                            withAuth()
                            setJsonBody(body)
                        }.fold(
                            onSuccess = {
                                GlobalCustomerState.value = CustomerState.LoggedOut
                                state = Stage2State.SUCCESS
                                errorText = null
                            },
                            onFailure = { error ->
                                errorText = if (error is ClientRequestException) {
                                    error.response.bodyAsText().let {
                                        when (it) {
                                            "invalid_token" -> "Dieser Link ist ungültig oder bereits abgelaufen."
                                            "passwords_must_match" -> "Altes und neues Passwort müssen übereinstimmen"
                                            else -> "Ein Fehler ist aufgetreten"
                                        }
                                    }
                                } else {
                                    "Ein Fehler ist aufgetreten"
                                }
                            },
                        )
                    }
                ) {
                    P(attrs = { classes("text-center") }) {
                        Span { Text("Geben Sie hier die E-Mail Ihres Benutzerkontos ein, und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.") }
                    }
                    YaFormTextInput(
                        prop = ForgotStage2.RequestBody::newPassword,
                        label = { Text("Neues Passwort") },
                        type = InputType.Password,
                        required = true,
                    )
                    YaFormTextInput(
                        prop = ForgotStage2.RequestBody::newPasswordRepeat,
                        label = { Text("Neues Passwort (Wiederholung)") },
                        type = InputType.Password,
                        required = true,
                    )
                    YaFormButton(ButtonType.Submit) {
                        Text("Zurücksetzen")
                    }
                }
            }
            Stage2State.SUCCESS -> {
                P(attrs = { classes("text-center") }) {
                    Text("Passwort erfolgreich zurückgesetzt.")
                    Br()
                    Anchor("/kundenportal/auth/login", {
                        role("button")
                        classes("outline")
                    }) {
                        Text("Zum Login")
                    }
                }
            }
        }
        ErrorCard(errorText)
    }
}
